<!-- 设置显示及语言 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                    parkCode:"2KPGDYCO",
                   showMsgList: [{
                        "showVipType": "1",
                        "showChannelType": "0",
                        "showPassMode": "0",
                        "showSafeMode":"0",
                         "otherAttr": "0",
                        "textMessage": "%P欢迎光临",
                        "voiceMessage": "%P欢迎光临",
                        "lastOperator":"张三",
                         "lastOperateTime": "2017-12-01 00:00:00"
                    },{
                        "showVipType": "1",
                        "showChannelType": "0",
                        "showPassMode": "0",
                        "showSafeMode":"0",
                         "otherAttr": "0",
                        "textMessage": "%P欢迎光临",
                        "voiceMessage": "%P欢迎光临",
                        "lastOperator":"李四",
                         "lastOperateTime": "2017-12-01 00:00:00"
                    }]
            },
            responseCode: {
                "data": {

                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台设置基本类型显示以及语言播报",
                t_url: this.commonUrls.test+"setShowMsg",
                p_url: this.commonUrls.prod+"setShowMsg",
                precondition: "VEMS 2.16及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'showMsgList', info2: '是', info3: 'JSONArray', info4: '显示及语音列表' }
                        ]
                },{
                    titleName: "showMsgList",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'showVipType', info2: '是', info3: 'Integer', info4: 'VIP类型:1临时车,2本地VIP,3第三方VIP,4黑名单,5红名单,6本地VIP别称(时间类型),7本地VIP别称(次数类型),8本地VIP别称(余额类型),9通道关闭,10满位控制,11多位多车(满位),12卡机,13常开模式,14高峰模式,15预定车辆,16访客车辆,17共享车位,18ETC,19自助开闸,20手动关闸' },
                        { info1: 'showChannelType', info2: '是', info3: 'Integer', info4: '通道类型,0不限，1进场，2出场' },
                        { info1: 'showPassMode', info2: '是', info3: 'Integer', info4: '通行模式,0不限，1宽，2严' },
                        { info1: 'showSafeMode', info2: '是', info3: 'Integer', info4: '安全模式,0关闭，1开启' },
                        { info1: 'otherAttr', info2: '是', info3: 'Integer', info4: '额外属性和其他: 0无,1需要缴费,2不需要缴费,3时间有效期内，提醒期外,4时间有效期内，提醒期内,5时间有效期外，延时期内,6时间有效期外，删除期内,7时间有效期外，删除期内，需要缴费,8时间有效期外，删除期内，不需要缴费,9不限,10刚触发离场拍照的时候,11还卡机还卡时，还卡后检测未缴费的情况,12还卡机还卡时，还卡后检测已缴费的情况,13还卡机还卡时，还卡后检测卡片有异常的情况,14还卡机还卡时，还卡后检测已缴费但超时的情况,15不需要缴费,16有金额,不列入欠费,17有金额,列入欠费,18无通道权限,19满位控制,20超时,21ETC黑名单,22ETC余额不足,23ETC识别失败,24ETC结果不可信,25ETC扣费成功,26ETC扣费失败,27无缴费金额,27无缴费金额,28满位控制，系统无空位自动放行' },
                        { info1: 'textMessage', info2: '是', info3: 'String', info4: '显示屏显示信息模板: 如"%P欢迎光临,意为：粤G88888(%p)欢迎光临"。   %PT 代表 停车时长,%P 代表 车牌号,%C 代表 应缴金额,\\ 代表 换行,%ST 代表 停车时长,%TM 代表 时间，精确到秒,%TD 代表 时间，精确到日,%T1S1 代表 停车场1的总剩余车位,%VM 代表 本地VIP别称,%VT 代表 本地VIP剩余天数,%LVT 代表 本地VIP临时续期时间,%VTT 代表 本地VIP剩余次数,%LV 代表 本地VIP临时续的次数,%VB 代表 本地VIP剩余余额' },
                        { info1: 'voiceMessage', info2: '是', info3: 'String', info4: '显示屏显示信息模板: 如"%P欢迎光临,意为：粤G88888(%p)欢迎光临"。   %PT 代表 停车时长,%P 代表 车牌号,%C 代表 应缴金额,\\ 代表 换行,%ST 代表 停车时长,%TM 代表 时间，精确到秒,%TD 代表 时间，精确到日,%T1S1 代表 停车场1的总剩余车位,%VM 代表 本地VIP别称,%VT 代表 本地VIP剩余天数,%LVT 代表 本地VIP临时续期时间,%VTT 代表 本地VIP剩余次数,%LV 代表 本地VIP临时续的次数,%VB 代表 本地VIP剩余余额' },
                        { info1: 'lastOperator', info2: '是', info3: 'String', info4: '最后编辑操作员' },
                        { info1: 'lastOperateTime', info2: '是', info3: 'String', info4: '最后编辑时间,yyyy-MM-dd HH:mm:ss' },

                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/device/setShowMsg.vue